import StringHelper from './string'
import Capitalize from 'lodash/capitalize'
import moment from 'moment'

export default {
  getProductVariantIds(products, checkedProductIds) {
    if (checkedProductIds.length == 0 || products.length == 0) return

    let allProductVariantIds = []
    for (let i = 0; i < products.length; i++) {
      if (checkedProductIds.includes(products[i].id.toString())) {
        let variantIds = products[i].variants.map((each) => each.id)
        allProductVariantIds = [
          ...allProductVariantIds,
          products[i].id,
          ...variantIds
        ]
      }
    }
    return allProductVariantIds
  },

  // Product
  getDataForProductApi({
    businessId: businessId,
    product: product,
    variant: variant,
    lot: lot
  }) {
    let obj = {
      businessId: businessId,
      name: product.name,
      categoryId: product.categoryId,
      productFamily: 'cannabis',
      sort: 1,
      brandId: product.brandId,
      complianceType: product.complianceType,
      concentration_unit: product.concentration_unit,
      description: product.description,
      strain: product.strain,
      sku: product.sku,
      parentProductId: null,
      barcode: variant.barcode ? variant.barcode.toString() : null,
      variantName: variant.variantName,
      dryCannabisEquivalency: variant.dryCannabisEquivalency,
      featured: false,
      retired: false,
      lotTracking: lot.batch_lot ? true : false,
      caseSize: product.caseSize,
      longDescription: product.longDescription,
      featuredCategoryIds: product.featuredCategoryIds,
      licensedProducer: product.licensedProducer
    }
    return obj
  },
  getDataForCannabisProfileApi({
    locationId: locationId,
    variant: variant,
    lot: lot,
    fulfillment: fulfillment
  }) {
    let obj = {
      locationId: locationId,
      thc_cbd_value_type: variant.thc_cbd_value_type,
      totalTerp: StringHelper.emptyStringToNull(lot.totalTerp),
      fullfillmentTime: fulfillment ? parseInt(fulfillment) : null
    }
    if (lot.cbd || lot.cbd === 0) {
      obj.cbd = lot.cbd
    }
    if (lot.cbd_min || lot.cbd_min === 0) {
      obj.cbd_min = lot.cbd_min
    }
    if (lot.cbd_max || lot.cbd_max === 0) {
      obj.cbd_max = lot.cbd_max
    }
    if (lot.thc_min || lot.thc_min === 0) {
      obj.thc_min = lot.thc_min
    }
    if (lot.thc_max || lot.thc_max === 0) {
      obj.thc_max = lot.thc_max
    }
    if (lot.thc || lot.thc === 0) {
      obj.thc = lot.thc
    }
    return obj
  },
  getDataForProductPricingApi({ locationId: locationId, variant: variant }) {
    let obj = {
      locationId: locationId,
      price: parseFloat(variant.price),
      sale_price: variant.sale_price
        ? parseFloat(variant.sale_price)
        : parseFloat(variant.price),
      onlineSalePrice: variant.onlineSalePrice
        ? parseFloat(variant.onlineSalePrice)
        : parseFloat(variant.price),
      cost: parseFloat(variant.cost),
      stock: 0,
      stock_threshold: 0,
      reservedQty: 0,
      activeStock: 0
    }
    return obj
  },
  getDataForBatchApi({ locationId: locationId, lot: lot }) {
    let obj = {
      locationId: locationId,
      batch_lot: lot.batch_lot?.toString(),
      packaged_on: lot.packaged_on,
      badge_running: lot.badge_running,
      current_nou: parseInt(lot.current_nou),
      cost: parseFloat(lot.lot_cost),
      on_hold: false,
      totalTerp: StringHelper.emptyStringToNull(lot.totalTerp)
    }
    if (lot.cbd || lot.cbd === 0) {
      obj.cbd = lot.cbd
    }
    if (lot.cbd_min || lot.cbd_min === 0) {
      obj.cbdMin = lot.cbd_min
    }
    if (lot.cbd_max || lot.cbd_max === 0) {
      obj.cbdMax = lot.cbd_max
    }
    if (lot.thc_min || lot.thc_min === 0) {
      obj.thcMin = lot.thc_min
    }
    if (lot.thc_max || lot.thc_max === 0) {
      obj.thcMax = lot.thc_max
    }
    if (lot.thc || lot.thc === 0) {
      obj.thc = lot.thc
    }
    return obj
  },
  getDataForNewBatchApi({ locationId: locationId, productId: productId, batch_lot: batch_lot }) {
    let obj = {
      locationId: locationId,
      batch_lot: batch_lot?.toString(),
      packaged_on: moment().format(),
      badge_running: false,
      current_nou: 0,
      cost: 0,
      on_hold: false,
      totalTerp: null,
      thc: null,
      thcMin: null,
      thcMax: null,
      cbd: null,
      cbdMin: null,
      cbdMax: null,
      productId: productId,
      source: "po"
    }
    return obj
  },

  // PO
  getDataForPoApi({
    locationId: locationId,
    product: product,
    variant: variant,
    lot: lot
  }) {
    let obj = {
      name: product.name,
      locationId: locationId,
      categoryId: product.categoryId,
      brandId: product.brandId,
      description: product.description,
      productFamily: 'cannabis',
      complianceType: product.complianceType,
      strain: product.strain,
      concentration_unit: product.concentration_unit,
      supplierId: null,
      parentProductId: null,
      sku: product.sku,
      barcode: variant.barcode ? variant.barcode.toString() : null,
      variantName: variant.variantName,
      dryCannabisEquivalency: variant.dryCannabisEquivalency,
      retired: false,
      lotTracking: lot.batch_lot ? true : false,
      caseSize: product.caseSize,
      licensedProducer: product.licensedProducer,
      purchaseOrderItemId: null,
      longDescription: product.longDescription
    }
    return obj
  },
  poAddApiFromForm({ product: product, variant: variant, lot: lot }) {
    let obj = {
      productId: null,
      masterProductId: null,
      sku: product.sku,
      name: product.name,
      categoryId: product.categoryId,
      brandId: product.brandId,
      complianceType: product.complianceType,
      concentrationUnit: product.concentration_unit,
      description: product.description,
      strain: product.strain,
      sku: product.sku,
      barcode: variant.barcode ? variant.barcode.toString() : null,
      variantName: variant.variantName,
      dryCannabisEquivalency: variant.dryCannabisEquivalency
        ? parseFloat(variant.dryCannabisEquivalency)
        : null,
      lotTracking: lot.batch_lot ? true : false,
      caseSize: product.caseSize ? parseFloat(product.caseSize) : null,
      longDescription: product.longDescription,
      featuredCategoryIds: product.featuredCategoryIds,
      licensedProducer: product.licensedProducer,
      thc_cbd_value_type: variant.thc_cbd_value_type,
      totalTerp: StringHelper.emptyStringToNull(lot.totalTerp),
      price: parseFloat(variant.price),
      sale_price: variant.sale_price
        ? parseFloat(variant.sale_price)
        : parseFloat(variant.price),
      onlineSalePrice: variant.onlineSalePrice
        ? parseFloat(variant.onlineSalePrice)
        : parseFloat(variant.price),
      cost: parseFloat(variant.cost),
      batch_lot: lot.batch_lot?.toString(),
      packaged_on: lot.packaged_on,
      badge_running: lot.badge_running,
      current_nou: parseInt(lot.current_nou),
      cost: parseFloat(lot.lot_cost),
      on_hold: false,
      totalTerp: StringHelper.emptyStringToNull(lot.totalTerp)
    }
    if (lot.cbd || lot.cbd === 0) {
      obj.cbd = lot.cbd
    } else {
      obj.cbd = null
    }
    if (lot.cbd_min || lot.cbd_min === 0) {
      obj.cbdMin = lot.cbd_min
    } else {
      obj.cbdMin = null
    }
    if (lot.cbd_max || lot.cbd_max === 0) {
      obj.cbdMax = lot.cbd_max
    } else {
      obj.cbdMax = null
    }
    if (lot.thc_min || lot.thc_min === 0) {
      obj.thcMin = lot.thc_min
    } else {
      obj.thcMin = null
    }
    if (lot.thc_max || lot.thc_max === 0) {
      obj.thcMax = lot.thc_max
    } else {
      obj.thcMax = null
    }
    if (lot.thc || lot.thc === 0) {
      obj.thc = lot.thc
    } else {
      obj.thc = null
    }

    return obj
  },
  getPoAdd(product, lot = {}) {
    let extra
    let obj = {
      productId: product.id,
      masterProductId: product.masterProduct?.id
        ? product.masterProduct?.id
        : null,
      sku: product?.sku,
      name: product?.name,
      cost: product?.ppiCost,
      brand: product.brandId ? product.brand?.name : null,
      casegtin: null,
      productGtin: product?.barcode,
      packSize: product?.caseSize,
      concentrationUnit: product?.concentration_unit,
      licensedProducer: product?.producer?.licensedProducer,
      variantName: product?.variantName
    }
    if (lot?.id) {
      extra = {
        totalTerp: lot?.totalTerp,
        cbd: lot?.cbd,
        cbdMin: lot?.cbdMin,
        cbdMax: lot?.cbdMax,
        thc: lot?.thc,
        thcMin: lot?.thcMin,
        thcMax: lot?.thcMax,
        packagedOn: lot?.packaged_on,
        batchLot: lot?.batch_lot,
        cost: lot?.cost,
        nou: 0,
        noOfPackage: null
      }
    } else {
      extra = {
        totalTerp: product?.plcfTotalTerp,
        cbd: product?.cbd,
        cbdMin: product?.cbdMin,
        cbdMax: product?.cbdMax,
        thc: product?.thc,
        thcMin: product?.thcMin,
        thcMax: product?.thcMax,
        packagedOn: null,
        batchLot: null,
        nou: null,
        noOfPackage: null
      }
    }
    return { ...obj, ...extra }
  },
  getAuditAdd(product, lot = {}) {
    let obj = {
      productId: product.id,
    }
    if(lot?.id){
      obj.batchUploadDetailId = lot?.id
    }
    return obj
  },
  getPoMasterProductFromProduct(product){
    let masterProduct = {
      "aroma": [],
      "brand_id": null,
      "cbd": null,
      "cbd_max": null,
      "cbd_min": null,
      "complianceType": product?.complianceType ? product?.complianceType : null,
      "description": "",
      "id": -1,
      "image": product?.image ? product?.image : null,
      "longDescription": "",
      "name": product?.name ? product?.name : null,
      "producer": null,
      "size": product?.variantName ? product?.variantName : null,
      "strain": product?.strain ? product?.strain : null,
      "terpene": [],
      "thc": null,
      "thc_cbd_value_type": "single",
      "thc_max": null,
      "thc_min": null,
      "weight_equivalent_dry_cannabis": product?.dryCannabisEquivalency ? product?.dryCannabisEquivalency : null
    }
    return masterProduct
  },
  loadProductDataForDefaultForm(form, item) {
    form.name = StringHelper.parseString(item.name)
    form.brandId = StringHelper.parseNumber(item.brandId)
    form.categoryId = StringHelper.parseNumber(item.categoryId)
    form.strain = StringHelper.parseString(item.strain)
    form.complianceType = StringHelper.parseComplianceType(item.complianceType)
    form.sku = StringHelper.parseString(item.sku)
    form.concentration_unit = StringHelper.parseString(item.concentration_unit)
    form.description = StringHelper.parseString(item.description)
    form.longDescription = StringHelper.parseString(item.longDescription)
    form.licensedProducer = StringHelper.parseString(
      item.producer?.licensedProducer
    )
    form.caseSize = StringHelper.parseString(item.caseSize)
    form.lotTracking = StringHelper.parseString(item.lotTracking)
    form.exemptFromScanning = StringHelper.parseString(item.exemptFromScanning)
  },
  loadCannabisDataForDefaultForm(form, item) {
    form.thc_cbd_value_type = StringHelper.parseThcCbdValueType(
      item.thc_cbd_value_type
    )
    form.thc = StringHelper.parseNumber(item.thc)
    form.thc_min = StringHelper.parseNumber(item.thc_min)
    form.thc_max = StringHelper.parseNumber(item.thc_max)
    form.cbd = StringHelper.parseNumber(item.cbd)
    form.cbd_min = StringHelper.parseNumber(item.cbd_min)
    form.cbd_max = StringHelper.parseNumber(item.cbd_max)
    form.totalTerp = StringHelper.parseNumber(item.totalTerp)
  },
  loadPricingDataForDefaultForm(form, item) {
    form.stock = StringHelper.parseNumber(item.stock)
    form.stock_threshold = StringHelper.parseNumber(item.stock_threshold)
  },
  loadDataFromAsnForDefaultForm(form, asn) {
    form.description = asn?.masterProduct?.description
      ? asn?.masterProduct?.description
      : ''
    form.longDescription = asn?.masterProduct?.longDescription
      ? asn?.masterProduct?.longDescription
      : ''
    form.thc = StringHelper.parseNumber(asn.thc)
    form.thc_min = StringHelper.parseNumber(asn.thcMin)
    form.thc_max = StringHelper.parseNumber(asn.thcMax)
    form.cbd = StringHelper.parseNumber(asn.cbd)
    form.cbd_min = StringHelper.parseNumber(asn.cbdMin)
    form.cbd_max = StringHelper.parseNumber(asn.cbdMax)
    form.totalTerp = StringHelper.parseNumber(asn.totalTerp)
  },
  // get markup percent should show 10%, 12%, or Error on undefined
  saleMarginMarkup(price, cost, type = 'margin') {
    if ((price || price === 0) && (cost || cost === 0)) {
      let profit = price - cost
      let result = null
      if (type === 'margin') {
        result = (profit / price) * 100
      } else {
        result = (profit / cost) * 100
      }
      if (isFinite(result)) {
        return StringHelper.roundOff(result)
      } else {
        return 'error'
      }
    }
  },
  // return price based on markup margin, else asn.cost else 0
  calculatePrice(markupPrices, complianceType, val) {
    let currentMarkupPrice = markupPrices.find(
      (each) =>
        each.complianceType?.toLowerCase() ===
        complianceType?.replace(/[\s-]/g, '')?.toLowerCase()
    )
    if (currentMarkupPrice) {
      if (
        currentMarkupPrice &&
        currentMarkupPrice.status &&
        currentMarkupPrice.markupPercentage
      ) {
        // this.markupPercent = currentMarkupPrice.markupPercentage
        let value = parseFloat(val)
        let markupPercentage = parseInt(currentMarkupPrice.markupPercentage)

        let result = 0
        let decimal = 0
        if (currentMarkupPrice.markupType === 'margin') {
          let marginVal = 1 - markupPercentage / 100
          result = parseFloat(value) / marginVal
          return result ? result.toFixed(2) : ''
        } else {
          result = parseFloat(value) + (val * markupPercentage) / 100
          decimal = (result % 1).toFixed(2)
          if (decimal > 0) {
            return result ? +parseInt(result) + 0.99 : ''
          } else {
            return result ? +result.toFixed(2) : ''
          }
        }
      } else if (val) {
        return val
      } else {
        return 0
      }
    } else if (val) {
      return val
    } else {
      return 0
    }
  },
  // return markup margin type: Margin or Markup
  getMarkupMarginType(markupMargin, complianceType) {
    let currentMarkupMargin = markupMargin.find(
      (each) =>
        each.complianceType?.toLowerCase() ===
        complianceType?.toLowerCase()?.replace(/[\s-]/g, '')
    )
    return currentMarkupMargin?.markupType
      ? currentMarkupMargin?.markupType
      : null
  },
  getValidComplianceType(complianceType) {
    if (!complianceType) return ''
    let formattedComplianceType = Capitalize(complianceType?.toLowerCase())
    let validComplianceTypes = [
      'Dried flower',
      'Pre rolled',
      'Extracts ingested',
      'Extracts inhaled',
      'Edibles solids',
      'Edibles non-solids',
      'Topicals',
      'Accessory'
    ]
    return validComplianceTypes.includes(formattedComplianceType)
      ? formattedComplianceType
      : ''
  },
  getDataFromMergeToPO(asn, mergeProduct, locationId, markupPrices, fulfillment){
    let price = this.calculatePrice(markupPrices, mergeProduct.complianceType, asn.cost)
    let data = {
      product:{
        // from merge product
        lotTracking:mergeProduct.lotTracking?mergeProduct.lotTracking:false,
        name:mergeProduct.name,
        categoryId:mergeProduct.categoryId?mergeProduct.categoryId:null,
        brandId:mergeProduct.brandId?mergeProduct.brandId:null,
        strain:mergeProduct.strain,
        licensedProducer: mergeProduct.licensedProducer,
        complianceType:StringHelper.capitalize(mergeProduct.complianceType),
        concentration_unit:mergeProduct.concentration_unit,
        description:mergeProduct.description,
        longDescription:mergeProduct.longDescription,

        // from asn product
        parentProductId:mergeProduct?.id,
        sku:asn.sku,
        barcode:asn?.productGtin,
        variantName:asn.variantName,
        purchaseOrderItemId:asn.id,

        dryCannabisEquivalency:asn?.masterProduct?.weight_equivalent_dry_cannabis ? asn?.masterProduct?.weight_equivalent_dry_cannabis:"",
        locationId:locationId,
        productFamily:mergeProduct.complianceType?.toLowerCase()=='accessory'?'retail':'cannabis',
        supplierId:null,
        retired:false,
        caseSize:asn.packSize,
      },
      pricing: {
          locationId:locationId,
          cost:asn?.cost,
          price:price,
          sale_price:price,
          onlineSalePrice: price,
          stock:0,
          activeStock:0
      }, 
      cannabisProfile: {},
      mediaTerpen:{}
    }
    
    // cannabis profile
    if(mergeProduct.complianceType?.toLowerCase()==='accessory'){
      data.product.dryCannabisEquivalency = 0
      data.noCannabisProfile = true
      data.cannabisProfile = {
          locationId:locationId,
          thc:'',
          thc_min:'',
          thc_max:'',
          cbd:'',
          cbd_min:'',
          cbd_max:'',
          totalTerp:'',
          thc_cbd_value_type: '',
          fullfillmentTime:fulfillment
      }
    }else{
      data.cannabisProfile = {
          locationId:locationId,
          thc: asn.thc || asn.thc===0 ? asn.thc : '',
          thc_min: asn.thcMin || asn.thcMin===0 ? asn.thcMin : '',
          thc_max: asn.thcMax || asn.thcMax===0 ? asn.thcMax : '',
          cbd: asn.cbd || asn.cbd===0 ? asn.cbd : '',
          cbd_min: asn.cbdMin || asn.cbdMin===0 ? asn.cbdMin : '',
          cbd_max: asn.cbdMax || asn.cbdMax===0 ? asn.cbdMax : '',
          totalTerp: asn.totalTerp || asn.totalTerp===0 ? asn.totalTerp : '',
          fullfillmentTime: asn.fulfillmentTime ? asn.fulfillmentTime : fulfillment,
          thc_cbd_value_type: mergeProduct.thc_cbd_value_type ? mergeProduct.thc_cbd_value_type : 'single'
      }
    }

    // media, aroma, terpene
    if(asn?.masterProduct?.image) data.mediaTerpen.images = asn?.masterProduct?.image ? [asn?.masterProduct?.image] : []
    if(asn?.masterProduct?.aroma?.length>0) data.mediaTerpen.aromaIds = asn?.masterProduct?.aroma?.length>0 ? asn?.masterProduct?.aroma.map(item => item.id) : []
    if(asn?.masterProduct?.terpene?.length>0) data.mediaTerpen.terpenids = asn?.masterProduct?.terpene?.length>0 ? asn?.masterProduct?.terpene.map(item => item.id) : []

    
    // lot
    if(mergeProduct.lotTracking){
      let lotInfo = {
        locationId:locationId,
        shipmentId:asn.id,
        sku:asn.sku,
        batch_lot:asn.batchLot,
        name:mergeProduct.name,
        cost:asn.cost,
        packagedOn:asn.packagedOn,
        cbd:asn.cbd,
        cbdMax:asn.cbdMax,
        cbdMin:asn.cbdMin,
        thc:asn.thc,
        thcMax:asn.thcMax,
        thcMin:asn.thcMin,
        totalTerp:asn.totalTerp ? asn.totalTerp : 0
      }
      data.batch = lotInfo
    }
    return data
  }
}
